import moment from "moment";
import "moment-timezone";
export function getTimeSlots(startTime, endTime, interval) {
    let timeSlots = [];
    const start = moment(startTime, 'HH:mm');
    const end = moment(endTime, 'HH:mm');
    while (start <= end) {
        const slot = start.format('HH:mm');
        timeSlots.push(slot);
        start.add(interval, 'minutes');
    }
    timeSlots.push(end.format('HH:mm'));
    timeSlots = [...new Set(timeSlots)]
    return timeSlots;
}
export const ConvertToUTC = (date, timezone) => {
    const localDateTime = moment.tz(date, timezone); // Local datetime string in the UK time zone
    // Convert local datetime to UTC
    const utcDateTime = localDateTime.utc().format();
    return utcDateTime;
};